import { Block } from 'components/Shared/Layout';
import { BhImage } from 'models/BhImage';
import Image from 'components/Shared/Image';
import Button from 'components/Shared/Button';
import styles from './styles.scss';
import { getQaDataAttr } from '@bygghemmait/utilities';

interface CategoryLinksProps {
  title?: string;
  image?: BhImage;
  categoryUrl: string;
  id: string;
}

const SECTION_IMAGE_WIDTH_LARGE = 720;
const SECTION_IMAGE_HEIGHT_LARGE = 541;
const SECTION_IMAGE_WIDTH_SMALL = 266;
const SECTION_IMAGE_HEIGHT_SMALL = parseInt(styles.categoryImageHeightDesktop, 10);

const responsive = {
  srcSet: [
    {
      viewWidth: SECTION_IMAGE_WIDTH_LARGE,
      width: SECTION_IMAGE_WIDTH_LARGE,
      height: SECTION_IMAGE_HEIGHT_LARGE
    },
    {
      viewWidth: SECTION_IMAGE_WIDTH_SMALL,
      width: SECTION_IMAGE_WIDTH_SMALL,
      height: SECTION_IMAGE_HEIGHT_SMALL
    }
  ],
  sizes: `(min-width: 769px) ${SECTION_IMAGE_WIDTH_SMALL}px,
  ${SECTION_IMAGE_WIDTH_LARGE}px`
};

export default ({ title, image, categoryUrl, id }: CategoryLinksProps) => (
  <Block appearance="secondary" className={styles.categoryLinkBlock}>
    <a href={categoryUrl}>
      <Button
        outlined
        appearance="quaternary"
        className={styles.button}
        {...getQaDataAttr(`productgroupcard-${id}`)}
      >
        {title}
      </Button>
      <div className={styles.imageWrapper}>
        <Image
          {...image}
          height={SECTION_IMAGE_HEIGHT_LARGE}
          width={SECTION_IMAGE_WIDTH_LARGE}
          responsive={responsive}
          alt={title}
        />
      </div>
    </a>
  </Block>
);
